import { render } from "./CompanyInformationForm.vue?vue&type=template&id=4081c2a0&scoped=true"
import script from "./CompanyInformationForm.vue?vue&type=script&lang=js"
export * from "./CompanyInformationForm.vue?vue&type=script&lang=js"

import "./CompanyInformationForm.vue?vue&type=style&index=0&id=4081c2a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4081c2a0"]])

export default __exports__